import { apiSlice } from '../../api/apiSlice';

export const classApis = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMathSkillReport: builder.mutation({
      query: (options) => ({
        url: `CourseReport/${options.courseId}/Student/${options.studentId}/SkillReport`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getCourseUsageReport: builder.mutation({
      query: (options) => ({
        url: 'CourseReport/CourseUsageReport',
        method: 'GET',
        params:{...options},
        credentials: 'include'
      })
    })
  })
});

export const {
  useGetMathSkillReportMutation,
  useGetCourseUsageReportMutation
} = classApis;